import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Button } from '@digsup/components-button';
import './TypeControlBtn.scss';

const cx = classNames;

export const TypeControlBtn = ({ active, disabled, onClick, children }) => {
  const classes = cx('c-map-type-control-btn', {
    'c-map-type-control-btn--active': active,
    'c-map-type-control-btn--disabled': disabled,
  });

  return (
    <Button
      disabled={disabled}
      variant="tertiary"
      size="large"
      onClick={disabled ? null : onClick}
      className={classes}>
      <span className="c-map-type-control-btn__name">{children}</span>
    </Button>
  );
};

TypeControlBtn.propTypes = {
  active: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
};

TypeControlBtn.defaultProps = {
  disabled: false,
};
